export default "__VITE_ASSET__DoO91YYM__"